import { render, staticRenderFns } from "./tester.vue?vue&type=template&id=98c580b8&scoped=true&"
import script from "./tester.vue?vue&type=script&lang=js&"
export * from "./tester.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98c580b8",
  null
  
)

export default component.exports